import { render, staticRenderFns } from "./ImageAndText.vue?vue&type=template&id=de7b5ede&scoped=true&"
import script from "./ImageAndText.vue?vue&type=script&lang=js&"
export * from "./ImageAndText.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndText.vue?vue&type=style&index=0&id=de7b5ede&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7b5ede",
  null
  
)

export default component.exports